import React, { useEffect } from "react";
import Button from "../../../../ui/button/Button";
import history from "../../../../../utils/history";
import Panel from "../../../../ui/panel/Panel";
import Text from "../../../../ui/text/Text";
import "./SevenDaysBeforePaymentMethodExpiresEmailTemplate.scss";
import { AppState } from "../../../../..";
import { useDispatch, useSelector } from "react-redux";
import { IAuthReducerState } from "../../../../../reducers/authReducer";
import { ICompanyBrandingReducerState } from "../../../../../reducers/companyBrandingReducer";
import { Row, Col } from "react-grid-system";
import EmailPreivewContainer from "../../brand-customization/email-preview/EmailPreivewContainer";
import BackNavigationPanel from "../../../../ui/back-navigation-panel/BackNavigationPanel";
import { IEmailCustomizationReducerState } from "../../../../../reducers/emailCustomizationReducer";
import { resetEmailTemplateValues, getEmailTemplateValues } from "../../../../../actions/emailCustomizationActions";
import { fetchCompanyBranding } from "../../../../../actions/companyBrandingActions";
import EmailFooter from "../email-footer/EmailFooter";
import EmailEditableArea from "../email-editable-area/EmailEditableArea";
import { EmailTypes } from "../../../../../utils/grpc/generated/Billsby.Protos/Messenger/private/emailconfig/emailconfig_pb";

const SevenDaysBeforePaymentMethodExpiresEmailTemplate: React.FC = () => {
  const dispatch = useDispatch();
  const sbpme_companyBrandingReducer = useSelector<AppState, ICompanyBrandingReducerState>(state => state.companyBrandingReducer);
  const sbpme_emailCustomizationReducer = useSelector<AppState, IEmailCustomizationReducerState>(state => state.emailCustomizationReducer);
  const authReducer = useSelector<AppState, IAuthReducerState>(state => state.auth);
  
  const { highlightColor } = sbpme_companyBrandingReducer;
  const { customArea1, customArea2, customArea3 } = sbpme_emailCustomizationReducer;
  const { currentCompanyId, companyName, currentCompanyDomain } = authReducer;
  const defaultHighLightColor = "#F87847";

  useEffect(() => {
    dispatch(fetchCompanyBranding(currentCompanyDomain));
    dispatch(getEmailTemplateValues(currentCompanyId as number, companyName, EmailTypes.PAYMENT_METHOD_EXPIRING_SOON));
    return () => { dispatch(resetEmailTemplateValues()) };
  }, []);

  return (
    <div id="SevenDaysBeforePaymentMethodExpiresEmailTemplate-wrapper">
      <BackNavigationPanel
        title={"EMAIL_TEMPLATE_SEVEN_DAYS_BEFORE_PAYMENT_METHOD_EXPIRES_BACK_PANEL_TITLE"} shouldTranslateTitle={true}
        onClick={() => history.push("/configuration/email-notifications/emails/expiring-payment-methods")} />

      <Row>
        <Col sm={8}>
          <Panel className="seven-days-before-payment-method-expires-email-template__panel" noMargin>
            <EmailPreivewContainer>

              <Text
                content={<span dangerouslySetInnerHTML={{__html: customArea1}}></span>}
                shouldTranslate={false}
                className="email-preview__details__text email-preview__details__text-title bar bar-blue"
                component="span"
                noMargin
              />

              <Text
                content="EMAIL_TEMPLATE_SEVEN_DAYS_BEFORE_PAYMENT_METHOD_EXPIRES_GREETINGS"
                className="email-preview__details__text"
                component="span"
                noMargin
              />

              <Text
                content={<span dangerouslySetInnerHTML={{__html: customArea2}}></span>}
                shouldTranslate={false}
                className="email-preview__details__text bar bar-orange"
                component="span"
                noMargin
              />

              <Text
                content="EMAIL_TEMPLATE_SEVEN_DAYS_BEFORE_PAYMENT_METHOD_EXPIRES_BODY_1"
                className="email-preview__details__text email-preview__details__text-bold"
                component="span"
                noMargin
              />

              <Text
                content="EMAIL_TEMPLATE_SEVEN_DAYS_BEFORE_PAYMENT_METHOD_EXPIRES_BODY_2"
                className="email-preview__details__text"
                component="span"
                noMargin
              />

              <div className="email-preview__details__button align-left">
                <Button
                  id="select-plan-continue"
                  type="button"
                  className="email-preview__details__button-orange seven-days-before-payment-method-expires-email-template__button arrow-icon"
                  title="EMAIL_TEMPLATE_SEVEN_DAYS_BEFORE_PAYMENT_METHOD_EXPIRES_BUTTON_TEXT"
                  style={{ backgroundColor: !!highlightColor ? highlightColor : defaultHighLightColor }}
                />
              </div>

              <Text
                content={<span dangerouslySetInnerHTML={{__html: customArea3}}></span>}
                shouldTranslate={false}
                className="email-preview__details__text bar bar-green"
                component="span"
                noMargin
              />

              <Text
                content="EMAIL_TEMPLATE_SEVEN_DAYS_BEFORE_PAYMENT_METHOD_EXPIRES_REAGRDS"
                className="email-preview__details__text"
                component="span"
                noMargin
              />

              <Text
                content={companyName}
                className="email-preview__details__text"
                component="span"
                shouldTranslate={false}
                noMargin
              />
              <EmailFooter />
            </EmailPreivewContainer>
          </Panel>
        </Col>
        <Col sm={4}>
          <EmailEditableArea
            id="SevenDaysBeforePaymentMethodExpiresEmailTemplate"
            emailCustomCopyOneValue={customArea1}
            emailCustomCopyTwoValue={customArea2}
            emailCustomCopyThreeValue={customArea3}
            showCompanyAlertToggle={true}
            showProductAlertToggle={false}
            showPlanAlertToggle={false}
          />
        </Col>
      </Row>
    </div>
  )
}

export default SevenDaysBeforePaymentMethodExpiresEmailTemplate;